import React, { useCallback, useEffect, useState } from 'react';
import { Button, Modal } from '../../ui';

const ConfirmModal = (props) => {
  const { visible, confirmArgs, onClose } = props;
  // `confirmLabel` names what Confirm does when the plain word would be vague: "Send anyway".
  const { title, message, warning, confirmLabel } = confirmArgs;
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(visible);
  }, [visible]);
  const closeModal = useCallback(
    (result) => {
      if (onClose) onClose(result);
      else {
        setShow(false);
      }
    },
    [setShow, onClose]
  );
  return (
    <Modal show={show} animation={false} backdrop="static">
      <Modal.Header>
        <Modal.Title>{title || 'Confirm'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="modal-message">{message || 'Are you sure?'}</div>
        {warning && <div className="modal-warning">{warning}</div>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => closeModal(true)}>
          {confirmLabel || 'Confirm'}
        </Button>
        <Button variant="secondary" onClick={() => closeModal(false)}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
